/* 清水材木店：広告などから来たことを、お問い合わせの送信に「流入元」として残す（2026-10-24）。
   URL の gclid・utm などや外からの参照元を見つけたら、この端末の中（localStorage）にだけ90日覚える。外へは送らない。
   お問い合わせのフォーム（form_type が contact）にだけ、見えない欄を足す。メルマガ登録（form_type が customer）には足さない */
(function () {
  var KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var LAST = 'szk_src_last';
  var FIRST = 'szk_src_first';
  var DAYS = 90;
  function box() { try { return window.localStorage; } catch (e) { return null; } }
  function read(key) {
    var s = box();
    if (!s) return null;
    try {
      var v = JSON.parse(s.getItem(key) || 'null');
      return v && Date.now() - v.t <= DAYS * 864e5 ? v : null;
    } catch (e) { return null; }
  }
  function write(key, value) {
    var s = box();
    if (!s) return;
    try { s.setItem(key, JSON.stringify(value)); } catch (e) { /* 保存できない端末では何もしない */ }
  }
  function capture() {
    var q = new URLSearchParams(window.location.search);
    var found = {};
    var any = false;
    KEYS.forEach(function (k) {
      var v = q.get(k);
      if (v) { found[k] = v.slice(0, 200); any = true; }
    });
    var ref = document.referrer && document.referrer.indexOf(window.location.host) < 0 ? document.referrer.slice(0, 200) : '';
    if (!any && !ref) return;
    var rec = { t: Date.now(), p: window.location.pathname.slice(0, 120), r: ref, q: found };
    if (!read(FIRST)) write(FIRST, rec);
    write(LAST, rec);
  }
  function describe(rec) {
    if (!rec) return 'なし';
    var parts = Object.keys(rec.q || {}).map(function (k) { return k + '=' + rec.q[k]; });
    if (rec.r) parts.push('参照元=' + rec.r);
    parts.push('最初のページ=' + rec.p);
    parts.push('日時=' + new Date(rec.t).toISOString());
    return parts.join(' / ');
  }
  function attach() {
    var forms = document.querySelectorAll('form[action^="/contact"]');
    Array.prototype.forEach.call(forms, function (form) {
      var type = form.querySelector('input[name="form_type"]');
      if (!type || type.value !== 'contact') return;
      [['流入元（最後）', describe(read(LAST))], ['流入元（最初）', describe(read(FIRST))]].forEach(function (pair) {
        var name = 'contact[' + pair[0] + ']';
        if (form.querySelector('input[name="' + name + '"]')) return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = pair[1];
        form.appendChild(input);
      });
    });
  }
  capture();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
  else attach();
})();
